/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CurrentInvoiceSummary,
  KpiOverviewData,
  OpenInvoiceSummary,
  ProductClaimsOverview,
  SalesOrderItemAvailabilityByMonth,
} from '../models/index';
import {
    CurrentInvoiceSummaryFromJSON,
    CurrentInvoiceSummaryToJSON,
    KpiOverviewDataFromJSON,
    KpiOverviewDataToJSON,
    OpenInvoiceSummaryFromJSON,
    OpenInvoiceSummaryToJSON,
    ProductClaimsOverviewFromJSON,
    ProductClaimsOverviewToJSON,
    SalesOrderItemAvailabilityByMonthFromJSON,
    SalesOrderItemAvailabilityByMonthToJSON,
} from '../models/index';

export interface GetCurrentDeliveriesOfCurrentRetailerRequest {
    createdFrom?: Date;
    createdUntil?: Date;
}

export interface GetKpiDataOverviewOfCurrentRetailerRequest {
    customerOrderCreatedBetweenFrom?: Date;
    customerOrderCreatedBetweenUntil?: Date;
    salesOrderItemAvailabilityCreatedBetweenFrom?: Date;
    salesOrderItemAvailabilityCreatedBetweenUntil?: Date;
    invoiceCreatedBetweenFrom?: Date;
    invoiceCreatedBetweenUntil?: Date;
    creditNotesCreatedBetweenFrom?: Date;
    creditNotesCreatedBetweenUntil?: Date;
}

export interface GetOpenInvoiceOverviewOfCurrentRetailerRequest {
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
}

export interface GetSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequest {
    availabilityBetweenFrom: Date;
    availabilityBetweenUntil: Date;
}

/**
 * 
 */
export class DashboardResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getCurrentDeliveriesOfCurrentRetailer without sending the request
     */
    async getCurrentDeliveriesOfCurrentRetailerRequestOpts(requestParameters: GetCurrentDeliveriesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = (requestParameters['createdFrom'] as any).toISOString();
        }

        if (requestParameters['createdUntil'] != null) {
            queryParameters['createdUntil'] = (requestParameters['createdUntil'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/dashboard/current-deliveries`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCurrentDeliveriesOfCurrentRetailerRaw(requestParameters: GetCurrentDeliveriesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CurrentInvoiceSummary>>> {
        const requestOptions = await this.getCurrentDeliveriesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CurrentInvoiceSummaryFromJSON));
    }

    /**
     */
    async getCurrentDeliveriesOfCurrentRetailer(requestParameters: GetCurrentDeliveriesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CurrentInvoiceSummary>> {
        const response = await this.getCurrentDeliveriesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKpiDataOverviewOfCurrentRetailer without sending the request
     */
    async getKpiDataOverviewOfCurrentRetailerRequestOpts(requestParameters: GetKpiDataOverviewOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['customerOrderCreatedBetweenFrom'] != null) {
            queryParameters['customerOrderCreatedBetweenFrom'] = (requestParameters['customerOrderCreatedBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['customerOrderCreatedBetweenUntil'] != null) {
            queryParameters['customerOrderCreatedBetweenUntil'] = (requestParameters['customerOrderCreatedBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['salesOrderItemAvailabilityCreatedBetweenFrom'] != null) {
            queryParameters['salesOrderItemAvailabilityCreatedBetweenFrom'] = (requestParameters['salesOrderItemAvailabilityCreatedBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['salesOrderItemAvailabilityCreatedBetweenUntil'] != null) {
            queryParameters['salesOrderItemAvailabilityCreatedBetweenUntil'] = (requestParameters['salesOrderItemAvailabilityCreatedBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['invoiceCreatedBetweenFrom'] != null) {
            queryParameters['invoiceCreatedBetweenFrom'] = (requestParameters['invoiceCreatedBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['invoiceCreatedBetweenUntil'] != null) {
            queryParameters['invoiceCreatedBetweenUntil'] = (requestParameters['invoiceCreatedBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['creditNotesCreatedBetweenFrom'] != null) {
            queryParameters['creditNotesCreatedBetweenFrom'] = (requestParameters['creditNotesCreatedBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['creditNotesCreatedBetweenUntil'] != null) {
            queryParameters['creditNotesCreatedBetweenUntil'] = (requestParameters['creditNotesCreatedBetweenUntil'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/dashboard/kpi-data-overview`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKpiDataOverviewOfCurrentRetailerRaw(requestParameters: GetKpiDataOverviewOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KpiOverviewData>> {
        const requestOptions = await this.getKpiDataOverviewOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KpiOverviewDataFromJSON(jsonValue));
    }

    /**
     */
    async getKpiDataOverviewOfCurrentRetailer(requestParameters: GetKpiDataOverviewOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KpiOverviewData> {
        const response = await this.getKpiDataOverviewOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOpenInvoiceOverviewOfCurrentRetailer without sending the request
     */
    async getOpenInvoiceOverviewOfCurrentRetailerRequestOpts(requestParameters: GetOpenInvoiceOverviewOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/dashboard/invoice/open`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOpenInvoiceOverviewOfCurrentRetailerRaw(requestParameters: GetOpenInvoiceOverviewOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpenInvoiceSummary>> {
        const requestOptions = await this.getOpenInvoiceOverviewOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpenInvoiceSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getOpenInvoiceOverviewOfCurrentRetailer(requestParameters: GetOpenInvoiceOverviewOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpenInvoiceSummary> {
        const response = await this.getOpenInvoiceOverviewOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProductClaimsOverviewOfCurrentRetailer without sending the request
     */
    async getProductClaimsOverviewOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/dashboard/product-claims-overview`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductClaimsOverviewOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductClaimsOverview>> {
        const requestOptions = await this.getProductClaimsOverviewOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductClaimsOverviewFromJSON(jsonValue));
    }

    /**
     */
    async getProductClaimsOverviewOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductClaimsOverview> {
        const response = await this.getProductClaimsOverviewOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailer without sending the request
     */
    async getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequestOpts(requestParameters: GetSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['availabilityBetweenFrom'] == null) {
            throw new runtime.RequiredError(
                'availabilityBetweenFrom',
                'Required parameter "availabilityBetweenFrom" was null or undefined when calling getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailer().'
            );
        }

        if (requestParameters['availabilityBetweenUntil'] == null) {
            throw new runtime.RequiredError(
                'availabilityBetweenUntil',
                'Required parameter "availabilityBetweenUntil" was null or undefined when calling getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['availabilityBetweenFrom'] != null) {
            queryParameters['availabilityBetweenFrom'] = (requestParameters['availabilityBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['availabilityBetweenUntil'] != null) {
            queryParameters['availabilityBetweenUntil'] = (requestParameters['availabilityBetweenUntil'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/dashboard/salesorderavailabilities`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRaw(requestParameters: GetSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesOrderItemAvailabilityByMonth>> {
        const requestOptions = await this.getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesOrderItemAvailabilityByMonthFromJSON(jsonValue));
    }

    /**
     */
    async getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailer(requestParameters: GetSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesOrderItemAvailabilityByMonth> {
        const response = await this.getSalesOrderItemAvailabilitiesGroupByMonthOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
